// Plain mechanic (SC-H2). The always-available "I did it! ✓" button. Timer/counter are H3.
const T = (k, p) => window.HUD?.T?.(k, p) || k;

export const plain = {
  key: 'plain',
  matches: () => true,
  // ctx: { onFinish(result) }. result carries { actual_value?, actual_seconds? } — plain sends {}.
  render(host, exercise, ctx) {
    const btn = document.createElement('button');
    btn.className = 'hwp-bigdone';
    btn.type = 'button';
    btn.textContent = T('hw5_i_did_it');
    btn.onclick = () => ctx.onFinish({});
    host.appendChild(btn);
    return { stop() {} };
  },
  summary() { return ''; },
};
